import { combineReducers } from 'redux';
import transactionSummaryList from './TransactionSummaryList/reducer';
import createTransactionSummary from './CreateTransaction/reducer';

export default combineReducers({
  transactionSummaryList,
  createTransactionSummary,
});



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transactionSummary/state/reducer.js